import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./DiscountProgramReportSummary.module.css";

const DiscountProgramReportSummary = ({
  refreshData = () => {},
  refreshRef,
  addBtnRef,
  addLoyaltyRef,
  quickExport = () => {},
  exportRef,
  setShowAddDiscountProgram = () => {},
  setProgramType = () => {},
  setIsEdit = () => {},
}) => {
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              label="Quick Export"
              color="black"
              endIcon={<Shortcut keys={["Alt", "E"]} />}
              onClick={quickExport}
              isAccessible={true}
              ref={exportRef}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={addLoyaltyRef}
              label="Add Loyalty Program"
              color="violet"
              onClick={() => {
                setIsEdit(false);
                setShowAddDiscountProgram(true);
                setProgramType("LOYALTY");
              }}
              endIcon={<Shortcut keys={["Ctrl", "L"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={addBtnRef}
              label="Add Corporate Program"
              color="violet"
              onClick={() => {
                setIsEdit(false);
                setShowAddDiscountProgram(true);
                setProgramType("CORPORATE");
              }}
              endIcon={<Shortcut keys={["Ctrl", "D"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default DiscountProgramReportSummary;
